module.exports = __webpack_public_path__ + "img/ltkhome-2x.2770fae.jpg";